// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadcrumb_wrapper__1s1z2","crumbWrapper":"breadcrumb_crumbWrapper__EBYCT","crumb":"breadcrumb_crumb__Cv77T"};